import { useEffect, useState } from 'react'
import { formatLocalAirtime, remainingParts } from './countdownTime'
import { roomCountdownTarget, type RoomCountdownAccess } from './liveRoomCountdown'

export default function RoomCountdown(access: RoomCountdownAccess) {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1_000)
    return () => window.clearInterval(timer)
  }, [])
  const {label, target} = roomCountdownTarget(access, now.getTime())
  const time = target === null ? null : new Date(target)
  const remaining = time ? remainingParts(time, now) : null
  return (
    <section className="room-countdown" aria-label="Room posting countdown">
      <p className="room-countdown__label">{label}</p>
      {remaining && <div className="room-countdown__digits" aria-label={`${remaining.days} days, ${remaining.hours} hours, ${remaining.minutes} minutes and ${remaining.seconds} seconds`}>
        {([['Days',remaining.days],['Hours',remaining.hours],['Min',remaining.minutes],['Sec',remaining.seconds]] as const).map(([name,value]) => (
          <span key={name}><strong>{String(value).padStart(2,'0')}</strong><small>{name}</small></span>
        ))}
      </div>}
      {time && <p className="room-countdown__time">{access.publicCanPost ? 'Member chat closes' : 'Member chat opens'} {formatLocalAirtime(time)}</p>}
    </section>
  )
}
